import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

const titleStyle = (theme: Theme) => css({
  padding: 5,
  fontWeight: 700,
  fontSize: 16,
  textTransform: 'uppercase',
  border: `0 solid ${theme.reportColors.borderPrimary}`,
  borderWidth: '0 1px',
  'tr:first-of-type &': {
    borderTopWidth: 1,
    borderRadius: '8px 8px 0 0',
  },
});

const rowStyle = (theme: Theme) => css({
  breakInside: 'avoid',
  color: theme.reportColors.textPrimary,

  'tbody &:nth-of-type(2n)': {
    background: theme.reportColors.tableRowBackgroundPrimary,
  },
  'tbody &:nth-of-type(2n + 1)': {
    background: theme.reportColors.tableRowBackgroundSecondary,
  },
});

type ExportReportTableTitleRowProps = Readonly<{
  title: string;
}>;

export const ExportReportTableTitleRowComponent = (props: ExportReportTableTitleRowProps) => {
  return (
    <tr css={rowStyle}>
      <td colSpan={999} css={titleStyle}>{props.title}</td>
    </tr>
  );
};
